import { render, staticRenderFns } from "./WarehouseStorage.vue?vue&type=template&id=1f8ea162"
import script from "./WarehouseStorage.vue?vue&type=script&lang=js"
export * from "./WarehouseStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports